import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
  GoodsReceipt, GoodsReceiptCreateDTO, GoodsReceiptResponse
} from '../interfaces/procurement/goodsReceipt.interface';
import { LineSerialsRequest } from '../interfaces/inventory/serial.interface';

export const GoodsReceiptService = {
  listByInstitution: async (page = 0, size = 10): Promise<GoodsReceiptResponse> => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(`${ENDPOINTS.GOODS_RECEIPT.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data;
  },
  getById: async (id: string): Promise<GoodsReceipt> =>
    (await axios.get(ENDPOINTS.GOODS_RECEIPT.GET_BY_ID(id))).data,
  create: async (dto: GoodsReceiptCreateDTO): Promise<GoodsReceipt> =>
    (await axios.post(ENDPOINTS.GOODS_RECEIPT.CREATE, dto)).data,
  /** F6b: `serials` maps receipt line id -> serials, for serial-tracked items. */
  /** G5a: {@code exchangeRate} is the booking rate of a foreign receipt (absent: the table rate on the receipt date). */
  post: async (id: string, serials?: LineSerialsRequest, exchangeRate?: number): Promise<GoodsReceipt> =>
    (await axios.post(ENDPOINTS.GOODS_RECEIPT.POST(id), serials,
      exchangeRate ? { params: { exchangeRate } } : undefined)).data,
  reverse: async (id: string): Promise<GoodsReceipt> =>
    (await axios.post(ENDPOINTS.GOODS_RECEIPT.REVERSE(id))).data,
};
